<template>
  <div>
    <el-header>
      <h3 class="title">
        <div class="block">
          <span>微信公众号接入</span>
        </div>
      </h3>
    </el-header>
    <el-container v-show="step == 1">
      <el-main>
        <el-row type="flex" justify="center">
          <el-col class="max-block" :span="17">
              <div>
                <div class="sweep-code">
                  <div class="info-block-bg">
                    <div class="">
                      <div class="logo-wrapper">
                        <!-- <svg class="icon" aria-hidden="true">
                          <use xlink:href="#iconweixin"></use>
                        </svg> -->
                        <img :src='channelSet.head_img'/>
                      </div>
                    </div>
                    <div class="info-block-right">
                      <h4>{{channelSet.name}}</h4>
                      <p><span>标签</span> {{channelSet.tag}}</p>
                      <p><span>简介</span> {{channelSet.signature}}</p>
                    </div>
                  </div>
                </div>
                  <el-form :rules="rules" :model="channelSet" ref='form' label-width="250px" style="margin-left: -60px;">
                    <!-- <el-form-item label="启用智能机器人:">
                      <el-select v-model="channelSet.bot">
                        <el-option v-for="item in bots"
                          :key="item.value"
                          :label="item.label"
                          :value="item.value"
                        ></el-option>
                      </el-select>
                    </el-form-item> -->
                    <!-- <el-form-item label="是否开启转人工触发词">
                      <el-radio-group v-model="channelSet.triggerOn">
                        <el-radio :label='true'>是</el-radio>
                        <el-radio :label='false'>否</el-radio>
                      </el-radio-group>
                    </el-form-item> -->
                    <el-form-item label="转人工触发词:" prop="triggerWord" v-show="channelSet.triggerOn">
                      <el-input v-model="channelSet.triggerWord" placeholder="例如：人工，转人工"></el-input>
                      <el-tooltip class="item" content="1.可设置多个，多个触发词用英文逗号隔开：2.需要全部命中触发词，如：触发词为”转人工“则必须输入”转人工“才能转入人工" placement="right">
                        <el-button
                          type="text"
                          size="small"
                        >
                          <svg class="icon icon-warning" aria-hidden="true">
                            <use xlink:href="#icontixing" />
                          </svg>
                        </el-button>
                      </el-tooltip>
                    </el-form-item>
                    <el-form-item label="欢迎语:" prop="greeting">
                      <el-input v-model="channelSet.greeting" type="textarea"></el-input>
                    </el-form-item>
                    <el-form-item label="路由策略:">
                      <div class="d-flex">
                        <el-row type="flex" justify="space-between">
                          <el-col :span="10">
                            <el-select v-model="channelSet.routeStrategy">
                              <el-option
                              v-for="item in strategies"
                                :key="item.id"
                                :label="item.acdName"
                                :value="item.id"
                              ></el-option>
                            </el-select>
                          </el-col>
                        </el-row>
                      </div>
                    </el-form-item>
                    <el-form-item size="medium">
                      <el-row type="flex" justify="center">
                        <el-button size="medium" @click="cancel">取 消</el-button>
                        <el-button type="primary" size="medium" @click="save">保存</el-button>
                        <el-button type="primary" size="medium" @click="saveAndConfigMenu">保存并配置菜单</el-button>
                      </el-row>
                    </el-form-item>
              </el-form>
            </div>
          </el-col>
        </el-row>
      </el-main>
    </el-container>
    <menu-config v-if='step == 3' :appId='channelSet.appId' @cancel = "cancel" :triggerWord='channelSet.triggerWord' :isThirdParty=true></menu-config>
  </div>
</template>

<script>
import MenuConfig from '../MenuConfig'
export default {
  components: {
    MenuConfig
  },
  name: 'CodeAuthorize',
  data() {
    return {
      step: 1,
      bots: [{
        value: 'Bot1',
        label: '机器人1'
      }, {
        value: 'Bot2',
        label: '机器人2'
      }],
      channelSet: {
        name: '',
        appId: '',
        originId: '',
        appSecret: '',
        bot: '',
        triggerOn: true,
        triggerWord: '',
        greeting: '',
        routeStrategy: '',
        token: '',
        encodingAesKey: '',
        type: 1,
        platformId: 'weixin'
      },
      rules: {
        name: [
          { required: true, message: '请输入小程序名称', trigger: 'blur' }
        ],
        appId: [
          { required: true, message: '请输入appId', trigger: 'blur' }
        ],
        appSecret: [
          { required: true, message: '请输入appSecret', trigger: 'blur' }
        ],
        greeting: [
          { required: true, message: '请输入欢迎语', trigger: 'blur' },
          { min: 1, max: 100, message: '长度在 1 到 100 个字符', trigger: 'blur' }
        ],
        triggerWord: [
          { required: true, message: '请输入转人工触发词', trigger: 'blur' }
        ],
        token: [
          { required: true, message: '请输入token', trigger: 'blur' },
          { min: 3, max: 32, message: '必须为英文或数字，长度为3-32字符', trigger: 'blur' }
        ],
        encodingAesKey: [
          { required: true, message: '请输入encodingAesKey', trigger: 'blur' },
          { min: 43, max: 43, message: '消息加密密钥由43位字符组成，字符范围为A-Z,a-z,0-9', trigger: 'blur' }
        ]
      }
    }
  },
  props: {
    channelSetParam: Object,
    strategies: Array
  },
  mounted() {
    this.channelSet.routeStrategy = this.strategies[0].id
    if (this.channelSetParam && this.channelSetParam.type === 1) {
      this.channelSet = this.channelSetParam
      this.getAuthrizerInfo(null, this.channelSet.appId)
    } else {
      this.channelSet.bot = this.bots[0].value

      if (this.$route.query.auth_code) {
        const authCode = this.$route.query.auth_code
        this.getAuthrizerInfo(authCode)
      }
    }
  },
  methods: {
    getAuthrizerInfo(authCode, authorizerAppId) {
      var that = this
      this.$http.get(window.$envUtils('VUE_APP_BP_SERVICE') + '/channel/getAuthorizerInfo', {
        params: {
          authCode,
          authorizerAppId
        }
      }).then(function(response) {
        if (response.data.code === 2000) {
          const authorizerInfo = response.data.data

          that.channelSet.appId = authorizerInfo.appId
          that.channelSet.name = authorizerInfo.nick_name
          that.channelSet.originId = authorizerInfo.user_name
          that.channelSet.signature = authorizerInfo.signature
          that.channelSet.tag = authorizerInfo.principal_name
          that.channelSet.head_img = authorizerInfo.head_img

          that.$forceUpdate()
        } else {
          that.$message.error(response.data.msg)
        }
      }).catch(function(error) {
        console.log(error)
      })
    },
    save() {
      this.$refs.form.validate((valid) => {
        if (valid) {
          var that = this
          this.$http.post(window.$envUtils('VUE_APP_BP_SERVICE') + '/channel/set', {
            data: this.channelSet
          }).then(function(response) {
            that.$emit('changeView', 0)
          }).catch(function(error) {
            console.log(error)
          })
        }
      })
    },
    saveAndConfigMenu() {
      this.$refs.form.validate((valid) => {
        if (valid) {
          var that = this
          this.$http.post(window.$envUtils('VUE_APP_BP_SERVICE') + '/channel/set', {
            data: this.channelSet
          }).then(function(response) {
            that.step = 3
          }).catch(function(error) {
            console.log(error)
          })
        }
      })
    },
    cancel() {
      this.$emit('changeView', 0)
    }
  }
}
</script>
<style lang="scss" scoped>
.el-header {
  padding: 0;
  margin-bottom: 0;
  .title {
    margin-bottom: 0;
  }
}

.max-block {
  max-width: 800px;
  h4 {
    text-align: center;
    font-size: 20px;
    color: #333;
    margin-bottom: 35px;
  }

  .el-form-item {
    ::v-deep .el-form-item__label {
      color: #333;
    }
    ::v-deep .el-form-item__content {
      .el-input,
      .el-textarea,
      .el-select {
        width: 75%;
        margin-right: 10px;
      }
      .el-select {
        .el-input {
          width: 100%;
        }
      }
      .el-row {
        width: 75%;
        .el-input,
        .el-textarea,
        .el-select {
          width: 100%;
          margin-right: 0;
        }
      }
    }
  }
  ::v-deep .el-form-item__content {
    .d-flex {
      display: flex;
      margin-bottom: 20px;
      .el-row {
        margin-right: 10px;
      }
      .el-button {
        & + .el-button {
          margin-left: 10px;
        }
      }
    }
  }
}

.el-tooltip__popper {
  max-width: 100px;
}
</style>
